(ns portal.backup-image-ocp.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.backup-image :as backup-image.q]
            [common.widgets.upload :as upload]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer [{:keys [is-submitting file]}]
  ($ Button
     {:type "submit"
      :variant "contained"
      :disabled (or is-submitting (nil? file))}
     (if is-submitting "Uploading..." "Save Backup Image")))

(defui backup-image-form [{:keys [backup-image]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        dimensions (str (:width backup-image) "x" (:height backup-image))

        [file set-file] (uix/use-state nil)

        {:keys [mutate isPending error reset]} (use-mutation
                                                (backup-image.q/upload-backup-image-mutation
                                                 {:advertiser-id advertiser-id
                                                  :dimensions dimensions}))

        error-message (uix/use-memo (fn []
                                      (when error
                                        (or (some-> ^js (:data error) .-error .-message)
                                            "Failed to upload backup image")))
                                    [error])

        on-submit (uix/use-callback
                   (fn []
                     (let [form-data (js/FormData.)]
                       (.append form-data "backupimage" file)
                       (mutate form-data)))
                   [file mutate])

        on-change (uix/use-callback
                   (fn [file]
                     (reset)
                     (set-file file))
                   [reset])]
    ($ ocp
       {:title "Edit Backup Image"
        :footer ($ ocp-footer
                   {:is-submitting isPending
                    :file file})
        :on-submit on-submit}
       ($ :span dimensions)

       ($ upload/upload
          {:enablePreview true
           :enableEdit false
           :allow-macro? false
           :filetype "image"
           :maxSize (* 100 1000)
           :extensions ".jpg, .jpeg, .gif"
           :onChange on-change})

       (when error-message
         ($ Alert {:severity "error"}
            error-message)))))

(defocp backup-image-ocp :backup-image/edit [{:keys [backup-image]}]
  ($ backup-image-form {:backup-image backup-image}))
